export enum CLASS_REDUCER{
    CHANGE_STATE = 'changeState',
}
